/* eslint-disable no-param-reassign */
import React from 'react'

import { Route, Routes } from 'react-router-dom'

import PropTypes from 'prop-types'

import PageLayout from 'Pods/Layout/PageLayout'
import ContextBasedRouter from 'Pods/Shared/ContextBasedRouter'

import Dashboard from './Dashboard'

const breadcrumbs = [
  {
    title: 'CGTrader',
    url: '/',
    isActive: false,
  },
  {
    title: 'My Dashboard',
    url: null,
    isActive: true,
  },
]

const newLink = (
  <a href="/profile/upload/model" className="btn btn-primary">
    Upload 3D Model
  </a>
)

const PATHS = ['/', '/profile', '/de', '/es', '/fr', '/pt', '/ru', '/ja', '/zh-CN']

function DashboardLayout({
  layout,
  navigation,
  navClass,
  navId,
  footer,
}) {
  // Needed for acceptance tests
  if (!layout) layout = {}

  return (
    <ContextBasedRouter>
      <Routes>
        {PATHS.map((path) => (
          <Route
            key={path}
            path={path}
            element={(
              <PageLayout
                component={Dashboard}
                data={layout.sellerTier ? layout.sellerTier.data : null}
                meta={layout.sellerTier ? layout.sellerTier.meta : null}
                navigation={navigation}
                footer={footer}
                navClass={navClass}
                navId={navId}
                breadcrumbs={breadcrumbs}
                button={newLink}
                newRoyaltyUi={layout.newRoyaltyUi}
              />
            )}
          />
        ))}
      </Routes>
    </ContextBasedRouter>
  )
}

DashboardLayout.propTypes = {
  layout: PropTypes.shape({
    sellerTier: PropTypes.shape({
      data: PropTypes.object.isRequired,
      meta: PropTypes.object.isRequired,
    }),
    newRoyaltyUi: PropTypes.bool,
  }).isRequired,
  navigation: PropTypes.object.isRequired,
  navClass: PropTypes.string.isRequired,
  navId: PropTypes.string.isRequired,
  footer: PropTypes.object.isRequired,
}

export default DashboardLayout
